export const emailPlaceholder = { de: 'Email', en: 'Email', sv: 'Email' };
export const header = { de: 'Reset password', en: 'Reset password', sv: 'Återställ lösenord' };
export const successLabel = {
  de: 'An email has been sent with instructions on how to reset your password.',
  en: 'An email has been sent with instructions on how to reset your password.',
  sv: 'Ett email har skickats med instruktioner för att återställa ditt lösenord.',
};
export const loadingLabel = { de: 'Submitting...', en: 'Submitting...', sv: 'Skickar...' };
